import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { FormFieldBlueprint } from '@backstage/plugin-scaffolder-react/alpha';

const gitlabSpaceRepoPickerFormField = FormFieldBlueprint.make({
  name: 'gitlab-space-repo-picker',
  params: {
    field: () =>
      import('./GitlabSpaceRepoPicker').then(m => m.GitlabSpaceRepoPicker),
  },
});

const ownedLeasePickerFormField = FormFieldBlueprint.make({
  name: 'owned-lease-picker',
  params: {
    field: () => import('./OwnedLeasePicker').then(m => m.OwnedLeasePicker),
  },
});

export const gitlabSpaceRepoPickerModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [gitlabSpaceRepoPickerFormField, ownedLeasePickerFormField],
});
